import { SearchkitClient, useSearchkit } from '@searchkit/client';
import { uniq } from 'lodash';
import React, { useMemo } from 'react';
import QuickFilterList from '../../../common/components/filtering/QuickFilterList';

const getFilter = (api: SearchkitClient, identifier: string) => {
    const filters = api.getFiltersByIdentifier(identifier).map((filter) => filter.value);
    return filters || [];
};

export default ({ facets = [], quickFilters }) => {
    const api = useSearchkit();
    const newFilters = useMemo(() => {
        return (
            facets &&
            facets.length &&
            facets
                .filter((facet) => quickFilters.some((quickFilter) => quickFilter.identifier === facet.identifier))
                .map((facet) => {
                    const quickFilter = quickFilters.find((quickFilter) => quickFilter.identifier === facet.identifier);
                    const labelMap = quickFilter.labelMap;
                    const filterValues = getFilter(api, facet.identifier);
                    const filter = {
                        id: facet.identifier,
                        label: quickFilter.label || facet.label,
                        options: uniq([
                            ...facet.entries.map((entry) => labelMap?.[entry.label] ?? entry.label),
                            ...(Array.isArray(quickFilter?.optimisticState)
                                ? quickFilter.optimisticState.map((opt: { label: string }) => opt.label)
                                : [])
                        ]),
                        values: labelMap ? filterValues.map((v) => labelMap[v] ?? v) : filterValues,
                        tooltip: quickFilter.tooltip,
                        icon: quickFilter.icon
                    };
                    return filter;
                })
        );
    }, [facets, quickFilters]);

    const onFilterChange = (filter) => {
        const quickFilter = quickFilters.find((qf) => qf.identifier === filter.id);
        const reverseMap = quickFilter?.labelMap
            ? Object.fromEntries(Object.entries(quickFilter.labelMap).map(([k, v]) => [v, k]))
            : undefined;
        api.removeFiltersByIdentifier(filter.id);
        filter.values.forEach((val) => api.addFilter({ identifier: filter.id, value: reverseMap?.[val] ?? val }));
        api.search();
    };

    return <QuickFilterList filters={newFilters || []} onFilterChanged={onFilterChange} />;
};
